<div fxLayout="column" fxFlexFill *ngIf="!loader">

  <div class="divider layout-padd-2" *ngIf="currMerchant" ngClass.xs="layout-padd" fxLayoutAlign="start center"
    fxLayoutGap="10px">

    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div fxLayout="column">
      <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>

    </div>

  </div>
  <!-- *ngIf="!currMerchant" -->
  <div class=" divider layout-padd-2 title-filter-date" fxHide fxShow.xs 
    ngClass.xs="layout-padd-5" #pageTitle >

    <div fxLayoutAlign="center center" class="filter-date-vignette primary clicked"
      (click)="setFilteranim()">
      <i class="material-icons" *ngIf="!filterDateAnimFlag" style="color:white;">date_range</i>
      <i class="material-icons" *ngIf="filterDateAnimFlag" style="color:white;">keyboard_arrow_up</i>
    </div>

  </div>

  <div class="divider layout-padd-2" fxHide.xs>
    <app-filter-date-from-to [type]="'credits'" [merchant]="currMerchant" (setDataEvent)="setCredits($event)"
      (setLoaderEvent)='setcreditLoader($event)'>
    </app-filter-date-from-to>
  </div>

  <div [@toggleFilterDate]="getToggleFilterDate" class="cont-filter-date-fix" [ngStyle]="{'top.px': titlePositionTop}"
    fxHide fxShow.xs>
    <div class="layout-padd-2">
      <app-filter-date-from-to [type]="'credits'" (setDataEvent)="setCredits($event)"
        (setLoaderEvent)='setcreditLoader($event)'>
      </app-filter-date-from-to>
    </div>
  </div>

  <div fxFlex class="scrolled">

    <div class="scrolled-y">
    
      <table mat-table [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-w-table" matSort>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'credit_history.created'|translate}} </th>
          <td mat-cell *matCellDef="let credit">
            {{credit.date | dateFilter:"DD-MM-YYYY"}} | {{credit.date | dateFilter:"HH:mm"}} </td>
        </ng-container>

        <ng-container matColumnDef="user_denomination">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'credit_history.merchant'|translate}} </th>
          <td mat-cell *matCellDef="let credit"> {{credit.user_denomination | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="point_of_sale_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'credit_history.point_of_sales'|translate}} </th>
          <td mat-cell *matCellDef="let credit"> {{credit.point_of_sale_name | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="lettering">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Numéro </th>
          <td mat-cell *matCellDef="let credit"> {{credit.lettering}} </td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'credit_history.amount'|translate}} </th>
          <td mat-cell *matCellDef="let credit"> {{(credit.total* -1 )| priceFilter:
            credit.currency.symbol : credit.currency.decimal}} </td>
        </ng-container>

        <ng-container matColumnDef="print" stickyEnd>
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let credit">
            <div fxLayoutAlign="center center">

              <mat-icon class="great-ico clicked" matTooltip="{{'fidelityComponent.print'|translate}}" matTooltipPosition="below"
                (click)="goPrintTicket(credit.print)" angulartics2On="click" angularticsAction="openPrintNote"
                angularticsCategory="clientNotes">print</mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div fxLayoutAlign="center center" class="layout-padd"
        *ngIf="!creditLoader && !loader && dataSource.data.length < 1">
        <span class="mat-subheading-1">{{'credit_history.no_credits'|translate}}</span>
      </div>

      <app-popup-loader [flagLoading]="creditLoader" [size]="30" [statusMessage]="'credit_history.loader'|translate"
        [type]="'line'">
      </app-popup-loader>

    </div>

    <!-- <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator> -->
    <!-- <mat-paginator (page)="pageEvent=onPaginationChange($event)" showFirstLastButtons [length]="count"
      [pageSizeOptions]="[10, 20,50,100]"></mat-paginator> -->
     
      <!-- new -->
      <mat-paginator (page)="onPaginationChange($event)" showFirstLastButtons [length]="count"
      [pageSizeOptions]="[10, 20,50,100]"></mat-paginator>
  </div>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'credit_history.loader'|translate">
</app-popup-loader>